module.exports = __webpack_public_path__ + "static/media/pagina.343ad5c4.jpg";